import { db, dbGlobal } from "@/firebase";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { getFirestoreDatabase } from "@/firebase";

const state = {
  currentProgram: null,
  programId: null,
  selectedDatabaseId: null,
  domainError: null,
  admins: [],
  initialLocale: "en"
};

const actions = {
  async loadAdmins({ commit }) {
    try {
      const adminsRef = collection(dbGlobal, "admins");
      const querySnapshot = await getDocs(adminsRef);
      const admins = [];
      querySnapshot.forEach(function(docSnapshot) {
        // user is admin
        admins.push({
          userId: docSnapshot.data().userId,
          email: docSnapshot.data().email,
          name: docSnapshot.data().name,
          programs: docSnapshot.data().programs || [],
          organisations: docSnapshot.data().organisations || [],
          customerToken: docSnapshot.data().customerToken
        });
      });
      commit("setAdmins", admins);
    } catch (error) {
      console.error("Error loading admins:", error);
    }
  },

  async getProgram({ commit, getters }, payload) {
    let programSnapshot;
    try {
      const programRef = doc(db(), "programs", payload);
      programSnapshot = await getDoc(programRef);
    } catch (e) {
      commit("setCurrentProgram", null);
      console.error("Error fetching program:", e);
    }

    if (programSnapshot.exists()) {
      const programData = programSnapshot.data();
      const currentProgram = {
        ...programData,
        createdAt: programData.createdAt.toDate()
      };
      const favicon = document.getElementById("favicon");
      var programFavicon = "favicons/incentable.png";
      if (currentProgram.webTheme.favicon) {
        programFavicon = "favicons/" + currentProgram.webTheme.favicon;
      }
      favicon.setAttribute("href", programFavicon);
      commit("setInitialLocale", currentProgram.translate.locale);
      commit("setCurrentProgram", currentProgram);
    } else {
      commit("setCurrentProgram", null);
      console.error("Program not found");
    }
  },

  async setProgramId({ commit, dispatch, getters }, programId = null) {
    console.log("🏗️ setProgramId called with:", programId);
    dispatch("setDomainError", null);

    // If a specific program ID is provided (like in demo mode), use it directly
    if (programId) {
      console.log("🎯 Using provided program ID:", programId);
      commit("setProgramId", programId);
      await dispatch("getProgram", programId);
      return;
    }

    const host = window.location.host;
    console.log("🌐 Current host:", host);

    let siteSnapshot;
    let sites = [];

    try {
      console.log("📡 Fetching sites collection...");
      const sitesRef = collection(dbGlobal, "sites");
      siteSnapshot = await getDocs(sitesRef);
      console.log("📡 Sites collection fetched, empty:", siteSnapshot.empty);
    } catch (e) {
      console.error("❌ Error fetching sites:", e);
      // If we can't fetch sites due to auth issues, handle gracefully
      if (e.code === "permission-denied" || e.code === "unauthenticated") {
        console.log(
          "🔒 Permission denied for sites collection, returning early"
        );
        return;
      }
      siteSnapshot = [];
    }

    if (siteSnapshot && !siteSnapshot.empty) {
      siteSnapshot.forEach(docSnapshot => {
        const siteData = docSnapshot.data();
        // console.log("🏢 Site found:", {
        //   id: docSnapshot.id,
        //   activeDomain: siteData.activeDomain,
        //   program: siteData.program
        // });
        sites.push({
          ...siteData
        });
      });
    }

    console.log("🔍 Total sites found:", sites.length);
    const found = sites.find(el => el.activeDomain === host);
    console.log(
      "🎯 Domain match found:",
      !!found,
      found
        ? {
            activeDomain: found.activeDomain,
            program: found.program,
            databaseId: found.databaseId,
            id: found.id
          }
        : null
    );

    if (host === "localhost:8080" || host === "localhost:8081") {
      dispatch("clearCart"); // need to add a clear cart method for admins entering the site from the admin dashboard
      // ======== programId ========
      const id = "dxkKiRMcpF2rd2ikRbv7"; // Dealer Rewards
      // const id = "hZR1yqCTrVnnQy3XoNc1"; // Diamond league
      // const id = "0eLn49KYPcBzKl1v5CsZ"; // Surface
      // const id = "PzhkOS5QL6WWd1PJwTAc"; // LG sandbox??
      // const id = "mnaChZ4aVJqZdwMoKDce"; // Testing
      // const id = "LQURCdynqBYzrCbRheTa"; // LG partner rewards - Default
      // const id = "oRiIOoUbVXfPbogAquB1"; // LG partner rewards - Sydney
      // const id = "C2nhNQcu4yJiS8QXC5BH"; // Dealer rewards Clone 2 - Sydney
      // ======== databaseId ========
      const foundDatabaseId = "(default)"; // LG partner rewards
      // const foundDatabaseId = "sydney"; // LG partner rewards
      // ======== end databaseId ========
      console.log("*** Local Host ***");
      await getFirestoreDatabase(foundDatabaseId);
      console.log("🔄 Setting program ID to:", id);
      console.log("🔄 Setting selected database ID to:", foundDatabaseId);
      commit("setProgramId", id);
      commit("setSelectedDatabaseId", foundDatabaseId);
      console.log(
        "🔄 commited selected database ID to:",
        this.getters.selectedDatabaseId
      );
      await dispatch("getProgram", id);
      console.log("******");
    } else if (!found) {
      commit("setProgramId", null);
      dispatch("setDomainError", "nodomain");
      console.warn("🚨 Domain not found:", host);
      console.warn(
        "🚨 Available domains:",
        sites.map(s => s.activeDomain)
      );
      // Don't logout immediately - let the user see the error
      // Only logout if we're not in an authentication flow
      const isAuthenticating = getters.isAuthenticating;
      console.log(
        "🔍 Authentication state - isAuthenticating:",
        isAuthenticating,
        "currentUser:",
        !!getters.currentUser
      );
      if (getters.currentUser && !isAuthenticating) {
        // Add a small delay to ensure authentication flow is complete
        setTimeout(() => {
          console.log("🚨 Logging out due to invalid domain (not during auth)");
          dispatch("logout");
        }, 1000);
      }
    } else if (found && found.program === "") {
      commit("setProgramId", null);
      dispatch("setDomainError", "noprogram");
      console.warn("🚨 No program configured for domain:", host);
      // Don't logout immediately - let the user see the error
      // Only logout if we're not in an authentication flow
      const isAuthenticating = getters.isAuthenticating;
      console.log(
        "🔍 Authentication state - isAuthenticating:",
        isAuthenticating,
        "currentUser:",
        !!getters.currentUser
      );
      if (getters.currentUser && !isAuthenticating) {
        // Add a small delay to ensure authentication flow is complete
        setTimeout(() => {
          console.log(
            "🚨 Logging out due to missing program (not during auth)"
          );
          dispatch("logout");
        }, 1000);
      }
    } else {
      console.log("*** Found ***");
      const id = found.program;
      const databaseId = found.databaseId;
      console.log("✅ Setting program ID to:", id);
      console.log("✅ Setting selected database ID to:", databaseId);
      commit("setProgramId", id);
      commit("setSelectedDatabaseId", databaseId);
      console.log(
        "✅ commited selected database ID to:",
        this.getters.selectedDatabaseId
      );
      await dispatch("getProgram", id);
      console.log("******");
    }
  },
  setDomainError({ commit }, error) {
    commit("setDomainError", error);
  },
  setCurrentProgram({ commit }, payload) {
    commit("setCurrentProgram", payload);
  },
  setAdmins({ commit }, payload) {
    commit("setAdmins", payload);
  }
};

const mutations = {
  setInitialLocale(state, locale) {
    state.initialLocale = locale;
  },
  setProgramId(state, id) {
    state.programId = id;
  },
  setSelectedDatabaseId(state, id) {
    state.selectedDatabaseId = id;
  },
  setCurrentProgram(state, program) {
    state.currentProgram = program;
  },
  setDomainError(state, error) {
    state.domainError = error;
  },
  setAdmins(state, payload) {
    state.admins = payload;
  }
};

const getters = {
  initialLocale(state) {
    return state.initialLocale;
  },
  programId(state) {
    return state.programId;
  },
  selectedDatabaseId(state) {
    return state.selectedDatabaseId;
  },
  currentProgram(state) {
    return state.currentProgram;
  },
  domainError(state) {
    return state.domainError;
  },
  admins(state) {
    return state.admins;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
